import { useProcessorData } from '../../hooks/use-processor-data';
import { usePlatformComponentContext } from '../platform-component.context';
import { ProcessorDataContext, ProcessorDataProviderProps } from '../processor-data.context';

export const ProcessorDataAuthenticatedProvider = ({ children, merchant }: ProcessorDataProviderProps) => {
  const { locationId } = usePlatformComponentContext();

  const value = useProcessorData({ merchant, locationId, isPublic: false });
  return <ProcessorDataContext.Provider value={value}>{children}</ProcessorDataContext.Provider>;
};
